import { Box, Typography } from "@mui/material";

const PROJECTED_ALPHA_SUFFIX = "59";
const BAR_HEIGHT = 22;
const FILL_SEGMENT = { position: "absolute", left: 0, top: 0, bottom: 0 };

export function formatMoney(amount) {
    return `$ ${Number(amount).toLocaleString("es-AR")}`;
}

export function formatPercentage(value) {
    return `${Number(value).toLocaleString("es-AR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
}

export function FulfillmentBar({ fulfillment, projectedFulfillment, color }) {
    const cappedFulfillment = Math.min(fulfillment || 0, 100);
    const cappedProjected = Math.min(projectedFulfillment || 0, 100);

    return (
        <Box
            sx={{
                position: "relative",
                height: BAR_HEIGHT,
                borderRadius: 1,
                overflow: "hidden",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
        >
            <Box sx={{ ...FILL_SEGMENT, width: `${cappedProjected}%`, backgroundColor: `${color}${PROJECTED_ALPHA_SUFFIX}` }} />
            <Box sx={{ ...FILL_SEGMENT, width: `${cappedFulfillment}%`, backgroundColor: color }} />
        </Box>
    );
}

export function FulfillmentCell({ value }) {
    if (value == null) {
        return (
            <Typography variant="body2" sx={{ color: "text.secondary", textAlign: "center" }}>
                —
            </Typography>
        );
    }
    const color = value < 100 ? "error.main" : "success.main";
    return (
        <Typography variant="body2" sx={{ color, fontWeight: 600, textAlign: "center" }}>
            {formatPercentage(value)}
        </Typography>
    );
}
